export const SPEAKER_VIEW_PERMISSION = "speaker-view";

export const OTHERS_TAB = "others";
